import { useEffect, useMemo, useState } from "react";
import { PLAYBOOK_CATEGORY_LABELS } from "../../../constants/automapOperationsPlaybookConstants";
import { fetchPlaybookTemplates } from "../../../services/automapOperationsPlaybookApi";
import { CopyTemplateButton, PlaybookShell } from "./AdminPlaybookShared";

export default function AdminPlaybookTemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [category, setCategory] = useState("");

  useEffect(() => {
    setLoading(true);
    fetchPlaybookTemplates(category ? { category } : {})
      .then((data) => setTemplates(data.templates || []))
      .catch((err) => setError(err.message || "Error al cargar plantillas."))
      .finally(() => setLoading(false));
  }, [category]);

  const grouped = useMemo(() => {
    const map = {};
    templates.forEach((t) => {
      if (!map[t.category]) map[t.category] = [];
      map[t.category].push(t);
    });
    return map;
  }, [templates]);

  return (
    <PlaybookShell
      active="templates"
      title="Message Templates"
      description="Plantillas copyables para dealer success, inventario, leads, trust/safety y marketing."
    >
      <div className="dealer-state-box admin-playbook__filters">
        <label>
          Categoría
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">Todas</option>
            {Object.entries(PLAYBOOK_CATEGORY_LABELS).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </label>
      </div>

      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}

      {!loading && !templates.length ? <p className="dealer-state-box muted">Sin plantillas.</p> : null}

      {!loading &&
        Object.entries(grouped).map(([cat, items]) => (
          <section key={cat}>
            <h3>{PLAYBOOK_CATEGORY_LABELS[cat] || cat}</h3>
            {items.map((t) => (
              <div key={t.id}>
                <CopyTemplateButton templateId={t.id} label={`${t.title} (${t.channel})`} text={t.body} />
                {t.variables?.length ? (
                  <p className="muted">Variables: {t.variables.map((v) => `{{${v}}}`).join(", ")}</p>
                ) : null}
              </div>
            ))}
          </section>
        ))}
    </PlaybookShell>
  );
}
